/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import {
    GetKnowledgeCenterApiParameter,
    getKnowledgeCenterDetails as getKnowledgeCenterDetailsApi,
} from "@eisinc/App/Services/KnowledgeCenterService";

import { ApiHandler, createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetKnowledgeCenterApiParameter, any>;
export const XngRequestDataFromKnowledgeCenterApi: HandlerType = async props => {
    props.apiResult = await getKnowledgeCenterDetailsApi(props.apiParameter);
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const chain = [PopulateApiParameter, XngRequestDataFromKnowledgeCenterApi];

const loadKnowledgeCenterDetails = createHandlerChainRunner(chain, "LoadKnowledgeCenterDetails");
export default loadKnowledgeCenterDetails;
